import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import classnames from 'classnames';
import styles from './styles';

const typographyBuilder = (variant, classNameFunc, coreProps = {}) => {
    // eslint-disable-next-line react/display-name
    return (props) => {
        const allProps = { ...coreProps, ...props };

        // call function to get the named class for this element
        const defaultClassName = classNameFunc(allProps.classes);

        // remove the classes, className and children properties before assigning the rest
        // to the element, otherwise material-ui will raise warnings that we are trying to
        // override properties that are not present on the element
        const { strong, classes, className, children, ...rest } = allProps;

        // merge the default class name with any additional ones provided
        const classNames = classnames(defaultClassName, className, strong ? classes.strong : '');

        return (
            <Typography variant={variant} className={classNames} {...rest}>
                {children}
            </Typography>
        );
    };
}

export const CenteredMessage = withStyles(styles)(typographyBuilder('h2', classes => classes.centeredMessage));
export const Label = withStyles(styles)(typographyBuilder('body1', classes => classes.label));
export const H1 = withStyles(styles)(typographyBuilder('h1', classes => classes.h1));
export const H2 = withStyles(styles)(typographyBuilder('h2', classes => classes.h2));
export const H3 = withStyles(styles)(typographyBuilder('h3', classes => classes.h3));
export const H4 = withStyles(styles)(typographyBuilder('h4', classes => classes.h4));
export const H5 = withStyles(styles)(typographyBuilder('h5', classes => classes.h5));
export const H6 = withStyles(styles)(typographyBuilder('h6', classes => classes.h6));
export const Subtitle1 = withStyles(styles)(typographyBuilder('subtitle1', classes => classes.subtitle1));
export const Subtitle2 = withStyles(styles)(typographyBuilder('subtitle2', classes => classes.subtitle2));
export const Body1 = withStyles(styles)(typographyBuilder('body1', classes => classes.body1));
export const Body2 = withStyles(styles)(typographyBuilder('body2', classes => classes.body2));
export const Button = withStyles(styles)(typographyBuilder('button', classes => classes.button));
export const Caption = withStyles(styles)(typographyBuilder('caption', classes => classes.caption));
export const Overline = withStyles(styles)(typographyBuilder('overline', classes => classes.overline));
export const TextButton = withStyles(styles)(typographyBuilder('body1', classes => classes.textButton));
